import { Link } from "react-router-dom";
import NewsCard from "./NewsCard";

const Evenimente = () => {
  return (
    <>
      <div className="container-fluid jumbotron jumbotron-image py-5">
        <div className="container">
          <h1 className="display-3 fw-bold text-white">Evenimente</h1>
        </div>
      </div>
      <div className="container">
        <nav aria-label="breadcrumb" className="mb-3 mt-4 ms-3">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/">Acasă</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Evenimente
            </li>
          </ol>
        </nav>
        <div className="row" data-masonry='{"percentPosition": true }'>
          <div className="col-sm-6 col-lg-4">
            <NewsCard
              image="images/3.jpg"
              title="Simpozion #3"
              date="29 noiembrie 2025, ora 08:30"
              link="/three"
            />
          </div>
          <div className="col-sm-6 col-lg-4">
            <NewsCard
              image="images/2.jpg"
              title="Simpozion #2"
              date="16 noiembrie 2024, ora 08:30"
              link="/two"
            />
          </div>
          <div className="col-sm-6 col-lg-4">
            <NewsCard
              image="images/1.jpg"
              title="Simpozion #1"
              date="9 martie 2024, ora 10:00"
              link="/one"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Evenimente;
